import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, createStaticVNode as _createStaticVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "hello" }
const _hoisted_2 = {
  id: "mainButtons",
  style: {"position":"absolute","width":"400px","height":"700px","border":"1px solid #888","background":"#040b","left":"300px","top":"20px","font-size":"17px","border-radius":"10px","text-align":"left","padding":"10px","color":"#eea"}
}
const _hoisted_3 = {
  id: "buttons",
  style: {"position":"absolute","width":"200px","height":"140px","border":"1px solid #888","background":"#040b","left":"20px","top":"130px","font-size":"17px","border-radius":"10px","text-align":"left","padding":"10px"}
}
const _hoisted_4 = {
  id: "engine",
  style: {"position":"absolute","width":"200px","height":"500px","border":"1px solid #888","background":"#040b","left":"20px","top":"300px","font-size":"17px","border-radius":"10px","text-align":"left","padding":"10px"}
}
const _hoisted_5 = ["textContent"]
const _hoisted_6 = ["textContent"]
const _hoisted_7 = ["textContent"]
const _hoisted_8 = ["textContent"]
const _hoisted_9 = ["textContent"]
const _hoisted_10 = ["textContent"]
const _hoisted_11 = ["textContent"]
const _hoisted_12 = ["textContent"]
const _hoisted_13 = ["textContent"]
const _hoisted_14 = {
  id: "info",
  style: {"position":"absolute","width":"200px","height":"500px","border":"1px solid #888","background":"#040b","right":"20px","top":"20px","font-size":"17px","border-radius":"10px","text-align":"left","padding":"10px"}
}
const _hoisted_15 = {
  id: "canvas",
  ref: "webGl",
  class: "webGl",
  style: {"z-index":"-10","position":"absolute","left":"0","top":"0","width":"100%","height":"100%"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_text = _resolveComponent("el-text")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_AppCompass = _resolveComponent("AppCompass")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_el_text, { style: {"--el-text-color":"#fb0"} }, {
          default: _withCtx(() => _cache[11] || (_cache[11] = [
            _createTextVNode("Режим")
          ])),
          _: 1
        }),
        _cache[20] || (_cache[20] = _createElementVNode("hr", null, null, -1)),
        _cache[21] || (_cache[21] = _createElementVNode("br", null, null, -1)),
        _createVNode(_component_el_button, {
          plain: "",
          onClick: _cache[0] || (_cache[0] = ($event: any) => ($options.buttonClick('level_infinity_world_straight_road')))
        }, {
          default: _withCtx(() => _cache[12] || (_cache[12] = [
            _createTextVNode("Дрэг")
          ])),
          _: 1
        }),
        _cache[22] || (_cache[22] = _createTextVNode(" - заезд на короткую дистанцию по прямой ")),
        _cache[23] || (_cache[23] = _createElementVNode("br", null, null, -1)),
        _cache[24] || (_cache[24] = _createElementVNode("br", null, null, -1)),
        _createVNode(_component_el_button, {
          plain: "",
          onClick: _cache[1] || (_cache[1] = ($event: any) => ($options.buttonClick('level_infinity_world')))
        }, {
          default: _withCtx(() => _cache[13] || (_cache[13] = [
            _createTextVNode("Ралли")
          ])),
          _: 1
        }),
        _cache[25] || (_cache[25] = _createTextVNode(" - заезд по извилистой трассе на длинную дистанцию ")),
        _cache[26] || (_cache[26] = _createElementVNode("br", null, null, -1)),
        _cache[27] || (_cache[27] = _createElementVNode("br", null, null, -1)),
        _createVNode(_component_el_button, {
          plain: "",
          onClick: _cache[2] || (_cache[2] = ($event: any) => ($options.buttonClick('game_trophy')))
        }, {
          default: _withCtx(() => _cache[14] || (_cache[14] = [
            _createTextVNode("Трофи")
          ])),
          _: 1
        }),
        _cache[28] || (_cache[28] = _createTextVNode(" - заезд по пересечённой местности, нужно пройти контрольные точки ")),
        _cache[29] || (_cache[29] = _createElementVNode("br", null, null, -1)),
        _cache[30] || (_cache[30] = _createElementVNode("br", null, null, -1)),
        _createVNode(_component_el_button, {
          plain: "",
          onClick: _cache[3] || (_cache[3] = ($event: any) => ($options.buttonClick('level_asteroid')))
        }, {
          default: _withCtx(() => _cache[15] || (_cache[15] = [
            _createTextVNode("Пейнтбол")
          ])),
          _: 1
        }),
        _cache[31] || (_cache[31] = _createTextVNode(" - бой на автомобилях, оборудованных краскопушками ")),
        _cache[32] || (_cache[32] = _createElementVNode("br", null, null, -1)),
        _cache[33] || (_cache[33] = _createElementVNode("br", null, null, -1)),
        _createVNode(_component_el_button, {
          plain: "",
          onClick: _cache[4] || (_cache[4] = ($event: any) => ($options.buttonClick('level_asteroid')))
        }, {
          default: _withCtx(() => _cache[16] || (_cache[16] = [
            _createTextVNode("Захват флага")
          ])),
          _: 1
        }),
        _cache[34] || (_cache[34] = _createTextVNode(" - команды прячут флаги на пересечённой местности, затем ищут ")),
        _cache[35] || (_cache[35] = _createElementVNode("br", null, null, -1)),
        _cache[36] || (_cache[36] = _createElementVNode("br", null, null, -1)),
        _createVNode(_component_el_button, {
          plain: "",
          onClick: _cache[5] || (_cache[5] = ($event: any) => ($options.buttonClick('caravan')))
        }, {
          default: _withCtx(() => _cache[17] || (_cache[17] = [
            _createTextVNode("Караван")
          ])),
          _: 1
        }),
        _cache[37] || (_cache[37] = _createTextVNode(" - свободный поиск лута в окрестностях своих владений; лут появляется с известной игроку периодичностью; если игрок вовремя не собрал, могут подобрать гости (т.е. мотивируем и игрока, и других игроков - гостей владения; гостям показываем не весь лут, чтобы хозяину не так обидно было) ")),
        _cache[38] || (_cache[38] = _createElementVNode("br", null, null, -1)),
        _cache[39] || (_cache[39] = _createElementVNode("br", null, null, -1)),
        _createVNode(_component_el_button, { plain: "" }, {
          default: _withCtx(() => _cache[18] || (_cache[18] = [
            _createTextVNode("Дерби")
          ])),
          _: 1
        }),
        _cache[40] || (_cache[40] = _createTextVNode(" - сбрось всех соперников с закольцованной трассы ")),
        _cache[41] || (_cache[41] = _createElementVNode("br", null, null, -1)),
        _cache[42] || (_cache[42] = _createElementVNode("br", null, null, -1)),
        _createVNode(_component_el_button, {
          plain: "",
          onClick: _cache[6] || (_cache[6] = ($event: any) => ($options.buttonClick('player_place')))
        }, {
          default: _withCtx(() => _cache[19] || (_cache[19] = [
            _createTextVNode("Владение игрока")
          ])),
          _: 1
        }),
        _cache[43] || (_cache[43] = _createTextVNode(" - неигровой режим (3D-фон для действий со своими машинами) "))
      ]),
      _cache[98] || (_cache[98] = _createStaticVNode("<div id=\"gameSpecs\" style=\"display:none;position:absolute;width:450px;height:200px;border:1px solid #888;background:#040b;left:300px;top:20px;font-size:24px;border-radius:10px;text-align:left;padding:10px;color:#fff;\" data-v-738152f4><span id=\"gameSpecsName\" data-v-738152f4></span><hr data-v-738152f4> Статус: <br data-v-738152f4><span id=\"gameSpecsStatus\" data-v-738152f4></span><br data-v-738152f4><br data-v-738152f4><span id=\"gameSpecsControlPointDistanceCaption\" data-v-738152f4>Расстояние до контрольной точки:</span><br data-v-738152f4><span id=\"gameSpecsControlPointDistance\" data-v-738152f4></span><br data-v-738152f4><br data-v-738152f4></div>", 1)),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_el_button, {
          plain: "",
          onClick: _cache[7] || (_cache[7] = ($event: any) => ($options.buttonClick('change_camera')))
        }, {
          default: _withCtx(() => _cache[44] || (_cache[44] = [
            _createTextVNode("Камера")
          ])),
          _: 1
        }),
        _cache[47] || (_cache[47] = _createElementVNode("br", null, null, -1)),
        _createVNode(_component_el_button, {
          plain: "",
          onClick: _cache[8] || (_cache[8] = ($event: any) => ($options.buttonClick('change_car_show_mode')))
        }, {
          default: _withCtx(() => _cache[45] || (_cache[45] = [
            _createTextVNode("Физическая машина")
          ])),
          _: 1
        }),
        _cache[48] || (_cache[48] = _createElementVNode("br", null, null, -1)),
        _createVNode(_component_el_button, {
          plain: "",
          onClick: _cache[9] || (_cache[9] = ($event: any) => ($options.buttonClick('change_terrain_show_mode')))
        }, {
          default: _withCtx(() => _cache[46] || (_cache[46] = [
            _createTextVNode("Физическая поверхность")
          ])),
          _: 1
        }),
        _cache[49] || (_cache[49] = _createElementVNode("br", null, null, -1)),
        _createVNode(_component_el_checkbox, {
          onClick: _cache[10] || (_cache[10] = ($event: any) => ($options.buttonClick('change_auto_steering'))),
          id: "autoSteeringCheckbox",
          label: "Авторуль",
          size: "large"
        })
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_el_text, { style: {"--el-text-color":"#fb0"} }, {
          default: _withCtx(() => [
            _cache[50] || (_cache[50] = _createTextVNode("Сцепление: ")),
            _createElementVNode("span", {
              textContent: _toDisplayString(_ctx.carClutch),
              id: "carClutch"
            }, null, 8, _hoisted_5)
          ]),
          _: 1
        }),
        _cache[59] || (_cache[59] = _createElementVNode("br", null, null, -1)),
        _createVNode(_component_el_text, { style: {"--el-text-color":"#fb0"} }, {
          default: _withCtx(() => [
            _cache[51] || (_cache[51] = _createTextVNode("Передача: ")),
            _createElementVNode("span", {
              textContent: _toDisplayString(_ctx.carGear),
              id: "carGear"
            }, null, 8, _hoisted_6)
          ]),
          _: 1
        }),
        _cache[60] || (_cache[60] = _createElementVNode("br", null, null, -1)),
        _createVNode(_component_el_text, { style: {"--el-text-color":"#fb0"} }, {
          default: _withCtx(() => [
            _cache[52] || (_cache[52] = _createTextVNode("Скорость: ")),
            _createElementVNode("span", {
              textContent: _toDisplayString(_ctx.carSpeed),
              id: "carSpeed"
            }, null, 8, _hoisted_7)
          ]),
          _: 1
        }),
        _cache[61] || (_cache[61] = _createElementVNode("br", null, null, -1)),
        _createVNode(_component_el_text, { style: {"--el-text-color":"#fb0"} }, {
          default: _withCtx(() => [
            _cache[53] || (_cache[53] = _createTextVNode("Обороты: ")),
            _createElementVNode("span", {
              textContent: _toDisplayString(_ctx.carRpm),
              id: "carRpm"
            }, null, 8, _hoisted_8)
          ]),
          _: 1
        }),
        _cache[62] || (_cache[62] = _createElementVNode("br", null, null, -1)),
        _cache[63] || (_cache[63] = _createElementVNode("br", null, null, -1)),
        _createVNode(_component_el_text, { style: {"--el-text-color":"#fb0"} }, {
          default: _withCtx(() => [
            _cache[54] || (_cache[54] = _createTextVNode("Руль: ")),
            _createElementVNode("span", {
              textContent: _toDisplayString(_ctx.steering),
              id: "steering"
            }, null, 8, _hoisted_9)
          ]),
          _: 1
        }),
        _cache[64] || (_cache[64] = _createElementVNode("br", null, null, -1)),
        _createVNode(_component_el_text, { style: {"--el-text-color":"#fb0"} }, {
          default: _withCtx(() => [
            _cache[55] || (_cache[55] = _createTextVNode("Авторуль: ")),
            _createElementVNode("span", {
              textContent: _toDisplayString(_ctx.carAutoSteering),
              id: "carAutoSteering"
            }, null, 8, _hoisted_10)
          ]),
          _: 1
        }),
        _cache[65] || (_cache[65] = _createElementVNode("br", null, null, -1)),
        _cache[66] || (_cache[66] = _createElementVNode("br", null, null, -1)),
        _createVNode(_component_el_text, { style: {"--el-text-color":"#fb0"} }, {
          default: _withCtx(() => [
            _cache[56] || (_cache[56] = _createTextVNode("Направление: ")),
            _createElementVNode("span", {
              textContent: _toDisplayString(_ctx.carVector),
              id: "carVector"
            }, null, 8, _hoisted_11)
          ]),
          _: 1
        }),
        _cache[67] || (_cache[67] = _createElementVNode("br", null, null, -1)),
        _createVNode(_component_el_text, { style: {"--el-text-color":"#fb0"} }, {
          default: _withCtx(() => [
            _cache[57] || (_cache[57] = _createTextVNode("Сила: ")),
            _createElementVNode("span", {
              textContent: _toDisplayString(_ctx.carForce),
              id: "carForce"
            }, null, 8, _hoisted_12)
          ]),
          _: 1
        }),
        _cache[68] || (_cache[68] = _createElementVNode("br", null, null, -1)),
        _cache[69] || (_cache[69] = _createElementVNode("br", null, null, -1)),
        _createVNode(_component_el_text, { style: {"--el-text-color":"#fb0"} }, {
          default: _withCtx(() => [
            _cache[58] || (_cache[58] = _createTextVNode("Колёса: ")),
            _createElementVNode("span", {
              textContent: _toDisplayString(_ctx.carWheels),
              id: "carWheels"
            }, null, 8, _hoisted_13)
          ]),
          _: 1
        })
      ]),
      _createElementVNode("h1", null, _toDisplayString(_ctx.msg), 1),
      _createElementVNode("div", _hoisted_14, [
        _createVNode(_component_el_text, { style: {"--el-text-color":"#fb0"} }, {
          default: _withCtx(() => _cache[70] || (_cache[70] = [
            _createTextVNode("ПозицияX: "),
            _createElementVNode("span", { id: "positionX" }, null, -1)
          ])),
          _: 1
        }),
        _cache[82] || (_cache[82] = _createElementVNode("br", null, null, -1)),
        _createVNode(_component_el_text, { style: {"--el-text-color":"#fb0"} }, {
          default: _withCtx(() => _cache[71] || (_cache[71] = [
            _createTextVNode("ПозицияY: "),
            _createElementVNode("span", { id: "positionY" }, null, -1)
          ])),
          _: 1
        }),
        _cache[83] || (_cache[83] = _createElementVNode("br", null, null, -1)),
        _createVNode(_component_el_text, { style: {"--el-text-color":"#fb0"} }, {
          default: _withCtx(() => _cache[72] || (_cache[72] = [
            _createTextVNode("ПозицияZ: "),
            _createElementVNode("span", { id: "positionZ" }, null, -1)
          ])),
          _: 1
        }),
        _cache[84] || (_cache[84] = _createElementVNode("br", null, null, -1)),
        _cache[85] || (_cache[85] = _createElementVNode("br", null, null, -1)),
        _createVNode(_component_el_text, { style: {"--el-text-color":"#fb0"} }, {
          default: _withCtx(() => _cache[73] || (_cache[73] = [
            _createTextVNode("cellPhysX: "),
            _createElementVNode("span", { id: "cellPhysX" }, null, -1)
          ])),
          _: 1
        }),
        _cache[86] || (_cache[86] = _createElementVNode("br", null, null, -1)),
        _createVNode(_component_el_text, { style: {"--el-text-color":"#fb0"} }, {
          default: _withCtx(() => _cache[74] || (_cache[74] = [
            _createTextVNode("cellPhysZ: "),
            _createElementVNode("span", { id: "cellPhysZ" }, null, -1)
          ])),
          _: 1
        }),
        _cache[87] || (_cache[87] = _createElementVNode("br", null, null, -1)),
        _createVNode(_component_el_text, { style: {"--el-text-color":"#fb0"} }, {
          default: _withCtx(() => _cache[75] || (_cache[75] = [
            _createTextVNode("physSquares: "),
            _createElementVNode("span", { id: "physSquares" }, null, -1)
          ])),
          _: 1
        }),
        _cache[88] || (_cache[88] = _createElementVNode("br", null, null, -1)),
        _cache[89] || (_cache[89] = _createElementVNode("br", null, null, -1)),
        _createVNode(_component_el_text, { style: {"--el-text-color":"#fb0"} }, {
          default: _withCtx(() => _cache[76] || (_cache[76] = [
            _createTextVNode("numPolygons: "),
            _createElementVNode("span", { id: "numPolygons" }, null, -1)
          ])),
          _: 1
        }),
        _cache[90] || (_cache[90] = _createElementVNode("br", null, null, -1)),
        _cache[91] || (_cache[91] = _createElementVNode("br", null, null, -1)),
        _createVNode(_component_el_text, { style: {"--el-text-color":"#fb0"} }, {
          default: _withCtx(() => _cache[77] || (_cache[77] = [
            _createTextVNode("numPhysSquares: "),
            _createElementVNode("span", { id: "numPhysSquares" }, null, -1)
          ])),
          _: 1
        }),
        _cache[92] || (_cache[92] = _createElementVNode("br", null, null, -1)),
        _createVNode(_component_el_text, { style: {"--el-text-color":"#fb0"} }, {
          default: _withCtx(() => _cache[78] || (_cache[78] = [
            _createTextVNode("numGraphSquares: "),
            _createElementVNode("span", { id: "numGraphSquares" }, null, -1)
          ])),
          _: 1
        }),
        _cache[93] || (_cache[93] = _createElementVNode("br", null, null, -1)),
        _createVNode(_component_el_text, { style: {"--el-text-color":"#fb0"} }, {
          default: _withCtx(() => _cache[79] || (_cache[79] = [
            _createTextVNode("numSceneElements: "),
            _createElementVNode("span", { id: "numSceneElements" }, null, -1)
          ])),
          _: 1
        }),
        _cache[94] || (_cache[94] = _createElementVNode("br", null, null, -1)),
        _createVNode(_component_el_text, { style: {"--el-text-color":"#fb0"} }, {
          default: _withCtx(() => _cache[80] || (_cache[80] = [
            _createTextVNode("numMapElements: "),
            _createElementVNode("span", { id: "numMapElements" }, null, -1)
          ])),
          _: 1
        }),
        _cache[95] || (_cache[95] = _createElementVNode("br", null, null, -1)),
        _cache[96] || (_cache[96] = _createElementVNode("br", null, null, -1)),
        _createVNode(_component_el_text, { style: {"--el-text-color":"#fb0"} }, {
          default: _withCtx(() => _cache[81] || (_cache[81] = [
            _createTextVNode("numPhysWorldElements: "),
            _createElementVNode("span", { id: "numPhysWorldElements" }, null, -1)
          ])),
          _: 1
        }),
        _cache[97] || (_cache[97] = _createElementVNode("br", null, null, -1))
      ]),
      _withDirectives(_createVNode(_component_AppCompass, {
        id: "compass",
        degrees: 0,
        style: {"position":"absolute","right":"0","top":"600px","width":"300px","height":"300px"}
      }, null, 512), [
        [_vShow, $props.showCompass]
      ])
    ]),
    _createElementVNode("canvas", _hoisted_15, null, 512)
  ], 64))
}